var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactorOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.7 50.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.3,19.8h-21c-1.9-3.7-5.8-6.3-10.3-6.3c-1.9,0-3.8,0.5-5.4,1.3L71.5,3.7c-2.1-2.1-5.5-2.1-7.6,0c-2.1,2.1-2.1,5.5,0,7.6             l12.6,12.6c-0.1,0.4-0.1,0.9-0.1,1.4c0,6.4,5.2,11.6,11.6,11.6c4.5,0,8.4-2.6,10.3-6.3h21c3,0,5.4-2.4,5.4-5.4             C124.7,22.2,122.3,19.8,119.3,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6,13.6c-4.5,0-8.4,2.6-10.3,6.3h-21c-3,0-5.4,2.4-5.4,5.4c0,3,2.4,5.4,5.4,5.4h21c1.9,3.7,5.8,6.3,10.3,6.3             c6.4,0,11.6-5.2,11.6-11.6C48.3,18.8,43.1,13.6,36.6,13.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactorOpenIcon);
export default __webpack_public_path__ + "static/media/contactor-open-icon.66aedf6b28491037e331ebb8fe23b44e.svg";
export { ForwardRef as ReactComponent };